import {
    Component,
    Input,
    Output,
    EventEmitter,
} from '@angular/core';
import { User, UserRoleMember } from '@intranet/modules/users';

@Component({
    selector: 'admin-user-table',
    templateUrl: './user-table.component.html',
    styleUrls: ['./user-table.component.scss'],
})
export class AdminUserTableComponent {
    @Input() roles: UserRoleMember[] = [];
    @Input() canDelete: boolean = false;
    @Output() selected = new EventEmitter<User>();
    @Output() sort = new EventEmitter<string>();

    sortBy: string = 'name';
    sortDir: 'asc' | 'desc' = 'asc';
    private _users: User[] = [];

    @Input() set users(value: User[]) {
        this._users = Array.isArray(value) ? [...value] : [];
        this.sortUsers();
    }

    get users(): User[] {
        return this._users;
    }

    onSort(column: string) {
        if (this.sortBy === column) {
            this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortBy = column;
            this.sortDir = 'asc';
        }

        // Apply sorting to users
        this.sortUsers();
    }

    sortUsers() {
        this._users = [...this._users].sort((a, b) => {
            let valueA: any;
            let valueB: any;

            switch (this.sortBy) {
                case 'name':
                    valueA = a.firstName.toLowerCase() + ' ' + a.surname.toLowerCase();
                    valueB = b.firstName.toLowerCase() + ' ' + b.surname.toLowerCase();
                    break;
                case 'email':
                    valueA = a.email.toLowerCase();
                    valueB = b.email.toLowerCase();
                    break;
                case 'shortname':
                    valueA = (a.shortName || a.firstName).toLowerCase();
                    valueB = (b.shortName || b.firstName).toLowerCase();
                    break;
                case 'team':
                    valueA = a.userGroup?.groupName?.toLowerCase() || '';
                    valueB = b.userGroup?.groupName?.toLowerCase() || '';
                    break;
                case 'roles':
                    valueA = this.rolesForUser(a.id).toLowerCase();
                    valueB = this.rolesForUser(b.id).toLowerCase();
                    break;
                case 'priceBand':
                    valueA = a.priceBand || 'None';
                    valueB = b.priceBand || 'None';
                    break;
                default:
                    return 0;
            }

            return this.sortDir === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
        });
    }

    rolesForUser(userId: string): string {
        const roles = this.roles.filter((r) => r.userId === userId);
        if (roles.length === 0) return 'None';

        return roles.map((r) => r.roleName).join(', ');
    }

    onSelect(user: User) {
        this.selected.emit(user);
    }
}
